module.exports = "<p>\n  node works!\n</p>\n"